export const SET_GOOGLE_LOGIN_ERROR = 'SET_GOOGLE_LOGIN_ERROR'

export const setGoogleLoginError = error => ({ type: SET_GOOGLE_LOGIN_ERROR, payload: error })
